/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';
import { AnyIfEmpty } from 'react-redux';
import {
    GET_STATE_LANDMARK_REQUEST,
    GET_STATE_LANDMARK_SUCCESS,
    GET_STATE_LANDMARK_FAILURE,
    GET_UNITS_REQUEST,
    GET_UNITS_FAILURE,
    GET_UNITS_SUCCESS,
} from '../constants/landmark.constants';

export type GetUnitsPayload = {
    locationIds: string[];
    startDateTime: string;
    endDateTime: string;
};

// Get Locations

const getLandmarkRequest = () => {
    return {
        type: GET_STATE_LANDMARK_REQUEST,
    };
};

const getLandmarkSuccess = (locationData: AnyIfEmpty<object>) => {
    return {
        type: GET_STATE_LANDMARK_SUCCESS,
        payload: locationData,
    };
};

const getLandmarkFailure = (locationError: string) => {
    return {
        type: GET_STATE_LANDMARK_FAILURE,
        payload: locationError,
    };
};

// Get Units

const getUnitsRequest = () => {
    return {
        type: GET_UNITS_REQUEST,
    };
};

const getUnitsSuccess = (unitsData: AnyIfEmpty<object>) => {
    return {
        type: GET_UNITS_SUCCESS,
        payload: unitsData,
    };
};

const getUnitsFailure = (error: string) => {
    return {
        type: GET_UNITS_FAILURE,
        payload: error,
    };
};

export const getStateLandmark = (searchText = '') => {
    return async (dispatch: AnyIfEmpty<object>) => {
        dispatch(getLandmarkRequest());
        return await axios
            .get('/admin/locations/location-names', {
                params: {
                    state: '',
                    cities: '[]',
                    searchText,
                },
            })
            .then(async (response) => {
                await dispatch(getLandmarkSuccess(response.data));
            })
            .catch((err) => dispatch(getLandmarkFailure(err.message)));
    };
};

export const getUnits = (data: GetUnitsPayload) => {
    const { locationIds, startDateTime, endDateTime } = data;
    return async (dispatch: AnyIfEmpty<object>) => {
        dispatch(getUnitsRequest());
        return await axios
            .get('/admin/units/idle-units', {
                params: {
                    locationIds: JSON.stringify(locationIds),
                    startDateTime,
                    endDateTime,
                },
            })
            .then(async (response) => {
                await dispatch(getUnitsSuccess(response?.data));
            })
            .catch((err) => dispatch(getUnitsFailure(err.message)));
    };
};
